import { FelaCSS } from '@bridebook/ui';

interface IStyles {
  contactWrap: FelaCSS;
}

const styles = (): IStyles => ({
  contactWrap: {
    marginBottom: '5px',
  },
});

export default styles;
